module.exports = __webpack_public_path__ + "media/images/star-on-1da4fbf9.png";